import React, { useEffect, useState } from "react";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { useNavigate } from "react-router-dom";
import {getData, postData} from '../middleware/apiMiddleware';
import {Button, Col, Form, Row, Modal} from 'react-bootstrap';
import './pdfitemcreation.css'; 

export default function Pdfitemcreation() {
  const navigate = useNavigate();
	
  const [updateClickedF, setUpdateClickedF] = useState(false);
	const [name, setName] = useState('');
	const [classCode, setClassCode] = useState('');
	const [rcSubject, setRcSubject] = useState('english');
	const [itemIds, setItemIds] = useState([]);
	const [categoryTags, setCategoryTags] = useState([]);
	const [tags, setTags] = useState([]);
	const [syllabusIds, setSyllabusIds] = useState([]);
	
	const [categoryTagsAllOption, setCategoryTagsAllOption] = useState([]);
	const [tagsAllOption, setTagsAllOption] = useState([]);
	const [syllabusesAllOption, setSyllabusesAllOption] = useState([]);
	
	const [nameF, setNameF] = useState(false);
	const [itemIdsF, setItemIdsF] = useState(false);
	const [categoryTagsF, setCategoryTagsF] = useState(false);
	const [tagsF, setTagsF] = useState(false);
	const [syllabusIdsF, setSyllabusIdsF] = useState(false);
	
	
	useEffect(() => {
		getData('item/listCategoryTags', navigate).then(res => setCategoryTagsAllOption(res.data));		
		getData('item/listTags', navigate).then(res => setTagsAllOption(res.data));		
		getData('item/listSyllabusItems', navigate).then(res => setSyllabusesAllOption(res.data));		
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	let handleSubmit = async (e) => {
    e.preventDefault();
      console.log(updateClickedF);
		if (updateClickedF) {
			return;
		}
		
		setUpdateClickedF(true);
    try {
			let obj = {};
			
			if (nameF) {
				obj['name'] = name;
			}
			//if (classCodeF) {
				obj['classCode'] = classCode;
			//}
			
			obj['rcSubject'] = rcSubject;
			
			
			if (categoryTagsF) {
				obj['categoryTags'] = categoryTags;
			}
			
			if (tagsF) {
				obj['tags'] = tags;
			}
			
			if (itemIdsF) {
				obj['itemIds'] = itemIds;
			}
			
			if (syllabusIdsF) {
				obj['syllabusIds'] = syllabusIds;
			}
			
			console.log(obj);
      await postData("item/createCourseItem", obj, navigate)
			.then(res => {
					navigate('/pdfitem/' + res.data.itemId);
				}
			);
    } catch (err) {
      console.log(err);
    }
  };
	//const [multiSelections, setMultiSelections] = useState([]);
	const [show, setShow] = useState(false);
	const [showType, setShowType] = useState("");
	const [newSubitemId, setNewSubitemId] = useState(0);
	
  const handleClose = () => {
		setShow(false);
		if (showType === 'itemIds') {

			if (newSubitemId !== 0) {
				setItemIds([...itemIds, newSubitemId]);
				setNewSubitemId(0);
				setItemIdsF(true);
			}
		}
	};
	
	const handleShow = (t) => {
		setShowType(t);
		setShow(true)
	};
	
	return (
		<div className="billContainer">
		<Form>
		
			<Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
					{
						(showType === 'categoryTags') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="categoryTagsOption"
							multiple
							onChange={(d) => {
								setCategoryTags(d);
								setCategoryTagsF(d.length > 0);
							}}
							options={categoryTagsAllOption}
							placeholder="Choose category tags..."
							selected={categoryTags}
					/>)
					}
					{(showType === 'tags') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="tagsOption"
							multiple
							onChange={(d) => {
								setTags(d);
								setTagsF(d.length > 0);								
							}}
							options={tagsAllOption}
							placeholder="Choose tag..."
							selected={tags}
						/>)
					}
					{(showType === 'syllabusIds') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey={(s) => `${s.id} - (${s.level})${s.name_en}`}
							multiple
							onChange={(d) => {
								let dm = d.reduce((p, c) => {
									return [...p, c.id];
								}, [])

								setSyllabusIds(dm);
								setSyllabusIdsF(dm.length > 0);
							}}
							options={syllabusesAllOption}
							placeholder="Choose syllabus..."
							filterBy={["id"]}
							selected={syllabusesAllOption.filter(x => {return ( syllabusIds.some(s => s === x.id) );})}
						/>)
					}
					{(showType === 'itemIds') && (<Form.Control type="number" min="1" placeholder="Enter id" onChange={
						(e)=> {
							setNewSubitemId(e.target.value);
						}
					} />
					)
					}
				</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
		
		
		
		
			
			<Form.Group as={Row}  className="mb-3" style={{ margin:"10px 0px",padding:"40px",borderRadius:"10px", backgroundColor:"#6A4A3D", color:"white"}}>
				<Col sm={"auto"}  style={{}}>
					<h2>{""}<span style={{fontWeight:"bold", fontStyle:"italic"}}>{"Create a new PDF"}</span>{""} </h2>
				</Col>
			</Form.Group>
			
      <Form.Group as={Row} className="mb-3">
				<Col sm={1}>
					{  !(nameF) ?
						<button className='billBtn billBtn-disabled' disabled>
							Create
						</button> :
						<button className='billBtn billBtn-default' type="submit" onClick={handleSubmit}>
							Create
						</button>
					}
				</Col>
			</Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="formName">
        <Form.Label column sm={1}>Name</Form.Label>
        <Col sm={12}>
          <Form.Control type="text" value={name} 
						onChange={
							e => { 
								setName(e.target.value); 
								if (e.target.value.length === 0) { 
									setNameF(false) 
								} else { 
									setNameF(true);
								}
							}
						} 
					/>
        </Col>
      </Form.Group>
			
      <Form.Group as={Row} className="mb-3" controlId="formRcSubject">
        <Form.Label column sm={1}>Subject</Form.Label>
				
        <Col sm={3}>
          <Form.Select value={rcSubject} 
						onChange={
							e => { 
								setRcSubject(e.target.value); 								
							} 
						} 
					>
            <option value="english">English</option>
            <option value="chinese">Chinese</option>
            <option value="math">Maths</option>
          </Form.Select>
        </Col>
				<Form.Label column sm={2}>Class Code</Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={classCode} 
						onChange={
							e => setClassCode(e.target.value)
						} 
					/>
        </Col>
      </Form.Group>
			

			<Row>
				<Form.Group as={Col} sm={6} className="mb-3">
					<Row className="formTitle" style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Category Tags</Form.Label>
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (categoryTags !== null && categoryTags.length > 0) ? categoryTags.map(ct => (
									<Col key={ct} sm={"auto"}>
										<span className="rectTag">{ct}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" 
										style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('categoryTags')}
									>
									Edit
								</span>
							</Col>
							<Col sm={"auto"}>
								<span className="rectTag" 
											style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => {
										setCategoryTags([]);
										setCategoryTagsF(false);
									}}
									>
									Reset
								</span>
							</Col>
							
							
						</Row>
					</Row>
				</Form.Group>

				<Form.Group as={Col} sm={6} className="mb-3" controlId="formCategoryTags">
					<Row className="formTitle" style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Level Tags</Form.Label>						
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (tags != null && tags.length > 0) ? tags.map(ct => (
									<Col key={ct} sm={"auto"}>
										<span className="rectTag">{ct}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" 
									style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('tags')}
									>
									Edit
								</span>
							</Col>
							<Col sm={"auto"}>
								<span className="rectTag" 
											style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => {
										setTags([]);
										setTagsF(false);
									}}
									>
									Reset
								</span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
			</Row>
			
			<Row>
				<Form.Group as={Col} sm={6} className="mb-3" controlId="formSyllabusIds">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Syllabus</Form.Label>						
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (syllabusIds != null && syllabusIds.length > 0) ? syllabusIds.map(ct => (
									<Col key={ct} sm={"auto"}>
										<span className="rectTag">{ct}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" 
									style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('syllabusIds')}
									>
									Edit
								</span>
							</Col>
							<Col sm={"auto"}>
								<span className="rectTag" 
									style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => {
										setSyllabusIds([]);
										setSyllabusIdsF(false);
									}}
									>
									Reset
								</span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
				<Form.Group as={Col} sm={6}  className="mb-3" controlId="formItemIds">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Subitems</Form.Label>
					
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{
								(itemIds != null && itemIds.length > 0) ? itemIds.map(ct => (
									<Col key={ct} sm={"auto"}>
										<span className="rectTag">{ct}</span>
									</Col>
									)
								) :
								<Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" 
									style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('itemIds')}
									>
									Add
								</span>
							</Col>
							<Col sm={"auto"}>
								<span className="rectTag" 
											style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => {
										setItemIds([]);
										setItemIdsF(false);
									}}
									>
									Reset
								</span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
				
				
				
			</Row>

    </Form>
		</div>
  );
}